module.exports = __webpack_public_path__ + "media/images/lb/635-c6a39b7d9e9e05f8d82ef9be46d4a3ed.svg";